export default (props) => {
  return props.children;
}
